namespace Matrix.Data {
    export interface AccountModelTargetRow {
        AccountModelTargetId?: number;
        AccountCode?: string;
        ModelCode?: string;
        TargetCode?: string;
        Nominal?: number;
        Tilt1?: number;
        Tilt2?: number;
        Tilt3?: number;
        Tilt4?: number;
        Tilt5?: number;
        Tilt6?: number;
        Tilt7?: number;
        Tilt8?: number;
        Tilt9?: number;
        Tilt10?: number;
        Target?: number;
        LowerLimit?: number;
        UpperLimit?: number;
        LowerWarning?: number;
        UpperWarning?: number;
        RowId?: number;
        Version?: number;
        CreatedBy?: string;
        CreatedWhen?: string;
        UpdatedBy?: string;
        UpdatedWhen?: string;
    }

    export namespace AccountModelTargetRow {
        export const idProperty = 'AccountModelTargetId';
        export const nameProperty = 'AccountCode';
        export const localTextPrefix = 'Data.AccountModelTarget';
        export const deletePermission = 'DataAdmin:AccountModelTargetTilt';
        export const insertPermission = 'DataAdmin:AccountModelTargetTilt';
        export const readPermission = 'Read:AccountModelTarget';
        export const updatePermission = 'DataAdmin:AccountModelTargetTilt';

        export declare const enum Fields {
            AccountModelTargetId = "AccountModelTargetId",
            AccountCode = "AccountCode",
            ModelCode = "ModelCode",
            TargetCode = "TargetCode",
            Nominal = "Nominal",
            Tilt1 = "Tilt1",
            Tilt2 = "Tilt2",
            Tilt3 = "Tilt3",
            Tilt4 = "Tilt4",
            Tilt5 = "Tilt5",
            Tilt6 = "Tilt6",
            Tilt7 = "Tilt7",
            Tilt8 = "Tilt8",
            Tilt9 = "Tilt9",
            Tilt10 = "Tilt10",
            Target = "Target",
            LowerLimit = "LowerLimit",
            UpperLimit = "UpperLimit",
            LowerWarning = "LowerWarning",
            UpperWarning = "UpperWarning",
            RowId = "RowId",
            Version = "Version",
            CreatedBy = "CreatedBy",
            CreatedWhen = "CreatedWhen",
            UpdatedBy = "UpdatedBy",
            UpdatedWhen = "UpdatedWhen"
        }
    }
}
